<template>
    <div class="uk-grid" uk-grid>
      <div class="uk-width-1-2@s uk-width-1-3@l">
        <div class="dropdown-select" data-dropdown-select>
          <div class="dropdown-select__placeholder">{{ $t('frontend-cinquanta3.download_collection.type') }}</div>
          <div class="dropdown-select__dropdown">
            <ul class="dropdown-select__list">
              <li v-for="option1 in lv1">
                <div class="dropdown-select__option" @click="selectLv1(option1.id)">{{ option1.name }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2@s uk-width-1-3@l">
        <div class="dropdown-select" :class="{ 'uk-disabled' : ! selectedLv1}" data-dropdown-select>
          <div class="dropdown-select__placeholder">{{ selectedLv2 }}</div>
          <div class="dropdown-select__dropdown">
            <ul class="dropdown-select__list">
              <li v-for="option2 in filteredLv2">
                <div class="dropdown-select__option" @click="selectFilterCategory(option2.id, option2.name)">{{ option2.name }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: {
    lv1: {
      type: Array,
    },
    lv2: {
      type: Array,
    },
  },
  data() {
    return {
      selectedLv1: false,
      selectedLv2Label: false,
      filteredLv2: Array,
    }
  },
  computed: {
    selectedLv2() {
      if(this.selectedLv2Label !== false){
        return this.selectedLv2Label;
      } else {
        return this.$t('frontend-cinquanta3.download_collection.category')
      }
    }
  },
  mounted() {
    this.selectedLv2Label = false;
  },
  methods: {
    selectLv1(item) {
      this.selectedLv1 = true
      let filteredLv2 = [];
      this.lv2.forEach(function (c) {
        if (c.parent_id === item) {
          filteredLv2.push(c)
        }
      });
      this.filteredLv2 = filteredLv2;
      this.selectFilterCategory(item, false);
    },
    selectFilterCategory(id, name) {
      this.selectedLv2Label = name;
      this.$root.$emit('select-download-filter-category', id);
    },
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/assets/js/theme-components/DataSheetFilters.vue